<!--
 * @Descripttion: TabBar
 * @FilePath: /mall-wap-vue/src/components/TabBar/index.vue
 * @Author: 张兴业
 * @Date: 2020-09-24 16:09:50
 * @LastEditors: 张兴业
 * @LastEditTime: 2020-09-27 22:56:47
-->
<template>
  <div class="bra">
    <van-tabbar active-color="var(--primary-color)" inactive-color="#000" route>
      <van-tabbar-item
        v-for="(item, index) in tabbars"
        :key="index"
        :to="item.path"
        replace
      >
        <span>{{ item.meta.title }}</span>
        <template slot="icon" slot-scope="props">
          <img :src="props.active ? item.meta.active : item.meta.normal" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import routes from "@/router/routes";

export default {
  data() {
    return {
      active: "home",
    };
  },
  computed: {
    tabbars() {
      const arr = routes.filter((route) => route.meta && route.meta.tabbar);
      if (arr.length) {
        return arr[0].children;
      }
      return [];
    },
  },
};
</script>
<style scoped>
.bra >>> .van-tabbar--fixed {
  box-shadow: 0px -3px 6px -3px rgba(193, 200, 207, 0.4);
}
.bra >>> .van-tabbar-item__icon img {
  height: 24px;
}
</style>
